var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"embeddedVoiceRecorder"},[_c('audio-recorder',{ref:"audioRecorder",attrs:{"time":_vm.maxMinutesLength,"after-recording":_vm.saveRecording}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }